import { jsx as t, jsxs as i, Fragment as E } from "react/jsx-runtime";
import { useId as F, useState as k, useRef as j, useEffect as L, useCallback as M } from "react";
import { useBreakpointValue as O, useMultiStyleConfig as U, useDisclosure as W, VStack as x, Flex as H, Popover as I, PopoverTrigger as q, PopoverContent as G, PopoverBody as J, Box as Q } from "@chakra-ui/react";
import { getValidChildren as X } from "../../../utils/getValidChildren.mjs";
import { defaultStepsState as Y, StepsContext as Z } from "./StepsContext.mjs";
import { StepsList as _ } from "./StepsList.mjs";
import { StepsStatus as N } from "./StepsStatus.mjs";
import { Typography as w } from "../../dataDisplay/Typography/Typography.mjs";
import { Progress as T } from "../../feedback/Progress/Progress.mjs";
import { Button as R } from "../../forms/Button/Button.mjs";
import "../../forms/Button/IconButton.mjs";
import "../../forms/Button/ButtonGroup.mjs";
import { ChevronUpIcon as ee, ChevronDownIcon as te } from "../../icons/componentIcons.mjs";
const de = ({
  children: P,
  activeStep: c = 1,
  "data-testid": a,
  isStepSelectDisabled: u = !1,
  id: f,
  onStepSelect: g,
  ...b
}) => {
  const o = O({ base: !0, md: !1 }, { fallback: "md" }), $ = U("Steps"), n = X(P), z = "gravity-steps", m = f || F(), [h, p] = k(0), { isOpen: v, onToggle: d, onClose: B } = W(), e = j([]), D = {
    ...Y,
    totalSteps: n.length,
    activeStep: c
  }, [r, y] = k(D);
  L(() => {
    c && y({ ...r, activeStep: c });
  }, [c]);
  const K = M(
    (l, s, C) => {
      s ? l.preventDefault() : (y({ ...r, activeStep: C }), g == null || g(C), d(), S());
    },
    [g, d]
  ), S = () => {
    p(0);
  }, V = () => {
    B(), S();
  }, A = (l) => {
    if (l.key === "ArrowUp" && h > 1) {
      const s = h - 1;
      p(s), e == null || e.current[s - 1].focus();
    } else if (l.key === "ArrowDown" && h < n.length) {
      const s = h + 1;
      p(s), e == null || e.current[s - 1].focus();
    } else
      l.key === "Home" ? (p(1), e == null || e.current[0].focus()) : l.key === "End" && (p(n.length), e == null || e.current[n.length - 1].focus());
  };
  return /* @__PURE__ */ t(
    Z.Provider,
    {
      value: {
        stepsState: r,
        handleStepSelection: K,
        isStepSelectDisabled: u,
        internalId: m,
        dataTestId: a,
        componentClassPrefix: z,
        childRefs: e
      },
      children: /* @__PURE__ */ i(
        x,
        {
          align: "stretch",
          spacing: o ? 4 : 2,
          ...o && { textAlign: "center" },
          id: m,
          "data-testid": a,
          ...b,
          role: "application",
          "aria-label": `On step ${r.activeStep} of ${n.length}.`,
          children: [
            /* @__PURE__ */ i(x, { spacing: 0, align: "stretch", children: [
              o && /* @__PURE__ */ i(w, { fontSize: "16px", children: [
                "Step ",
                r.activeStep
              ] }),
              /* @__PURE__ */ t(
                T,
                {
                  "aria-label": "Steps progress percentage",
                  value: r.activeStep / n.length * 95,
                  size: "sm",
                  id: `${m}-progress`,
                  "data-testid": a && `${a}-progress`
                }
              )
            ] }),
            /* @__PURE__ */ i(H, { alignItems: "center", children: [
              /* @__PURE__ */ i(
                I,
                {
                  placement: "bottom-start",
                  gutter: 8,
                  ...o && { matchWidth: !0 },
                  id: m,
                  isOpen: v,
                  onClose: V,
                  children: [
                    /* @__PURE__ */ t(q, { children: /* @__PURE__ */ t(
                      R,
                      {
                        type: "button",
                        variant: "tertiary",
                        rightIcon: v ? /* @__PURE__ */ t(ee, { variant: "light", size: "md" }) : /* @__PURE__ */ t(te, { variant: "light", size: "md" }),
                        size: o ? "lg" : "md",
                        ...o && { isFullWidth: !0 },
                        onClick: d,
                        "data-testid": a && `${a}-popover-trigger`,
                        "aria-label": `${u ? "Click to view steps." : "Click to navigate to another step."}`,
                        children: u ? "View steps" : "Change step"
                      }
                    ) }),
                    /* @__PURE__ */ t(
                      G,
                      {
                        onKeyDown: A,
                        "aria-label": "List of steps available. Press the up/down arrow keys to hightlight a step and the Enter key to select it. ",
                        children: /* @__PURE__ */ t(J, { sx: $.container, children: /* @__PURE__ */ t(_, { children: n }) })
                      }
                    )
                  ]
                }
              ),
              !o && /* @__PURE__ */ i(E, { children: [
                /* @__PURE__ */ t(Q, { flex: 1 }),
                /* @__PURE__ */ i(w, { children: [
                  "Step ",
                  r.activeStep
                ] })
              ] })
            ] }),
            /* @__PURE__ */ t(N, { activeStep: r.activeStep })
          ]
        }
      )
    }
  );
};
export {
  de as Steps
};
